import { render, staticRenderFns } from "./PriceFormat.vue?vue&type=template&id=caed2890"
import script from "./PriceFormat.vue?vue&type=script&lang=js"
export * from "./PriceFormat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports